import { render, staticRenderFns } from "./StatusBadge.vue?vue&type=template&id=a11f66fa&scoped=true&"
import script from "./StatusBadge.vue?vue&type=script&lang=ts&"
export * from "./StatusBadge.vue?vue&type=script&lang=ts&"
import style0 from "./StatusBadge.vue?vue&type=style&index=0&id=a11f66fa&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a11f66fa",
  null
  
)

export default component.exports